if (!window.__bringDrawerToFront) {
  window.__drawerZBase = 1001;
  window.__drawerZCounter = window.__drawerZBase;
  window.__bringDrawerToFront = (el) => {
    if (!el) return;
    window.__drawerZCounter =
      (window.__drawerZCounter || window.__drawerZBase) + 1;
    el.style.zIndex = String(window.__drawerZCounter);
  };
}

if (!window.__isMobile) {
  const mobileMQ = window.matchMedia('(max-width: 1024px)');
  window.__isMobile = () => mobileMQ.matches;
  if (mobileMQ.addEventListener) {
    mobileMQ.addEventListener('change', () => {});
  }
}

(() => {
  const html = document.documentElement;
  const header = document.querySelector('.site-header__top');
  const drawer = document.getElementById('MobileDrawer');
  const toggles = document.querySelectorAll('.mobile-drawer__toggle');
  let savedScrollPosition = 0;

  if (!drawer || !toggles.length || !header) return;

  let lastHeaderHeight = -1;

  const updateOffset = () => {
    const h = header.offsetHeight;

    if (h === lastHeaderHeight) return;
    lastHeaderHeight = h;

    drawer.style.top = `${h}px`;
    drawer.style.height = `calc(100% - ${h}px)`;
  };
  updateOffset();
  window.addEventListener('resize', updateOffset);
  window.addEventListener('load', updateOffset);

  let resizeObserver = null;
  if ('ResizeObserver' in window) {
    resizeObserver = new ResizeObserver(updateOffset);
    resizeObserver.observe(header);
  }

  const openDrawer = () => {
    savedScrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;
    drawer.classList.add('is-open');
    html.classList.add('nav-open');
    document.body.style.top = `-${savedScrollPosition}px`;
    window.__bringDrawerToFront(drawer);
    trapFocus();
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    html.classList.remove('nav-open');
    document.body.style.top = '';
    window.scrollTo(0, savedScrollPosition);
    releaseFocus();
  };

  toggles.forEach((btn) => {
    btn.addEventListener('click', () => {
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });
  });

  document.addEventListener('click', (e) => {
    if (
      e.target.closest('.mobile-drawer') ||
      e.target.closest('.mobile-drawer__toggle')
    )
      return;
    if (!drawer.classList.contains('is-open')) return;
    closeDrawer();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  let firstFocusable, lastFocusable;

  const trapFocus = () => {
    const focusables = drawer.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    firstFocusable = focusables[0];
    lastFocusable = focusables[focusables.length - 1];

    const isTouchDevice =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (!isTouchDevice) {
      firstFocusable?.focus();
    }

    drawer.addEventListener('keydown', handleFocusTrap);
  };

  const releaseFocus = () => {
    drawer.removeEventListener('keydown', handleFocusTrap);
    const isTouchDevice =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (!isTouchDevice) {
      toggles[0].focus();
    }
  };

  function handleFocusTrap(e) {
    if (e.key !== 'Tab') return;

    if (e.shiftKey && document.activeElement === firstFocusable) {
      e.preventDefault();
      lastFocusable.focus();
    } else if (!e.shiftKey && document.activeElement === lastFocusable) {
      e.preventDefault();
      firstFocusable.focus();
    }
  }

  document.addEventListener('shopify:section:select', (event) => {
    if (!(window.Shopify && Shopify.designMode)) return;
    const sectionId = event?.detail?.sectionId;
    const selectedSection = sectionId
      ? document.getElementById(`shopify-section-${sectionId}`)
      : document.querySelector('.shopify-section-selected');
    if (!selectedSection) return;

    const sectionType = selectedSection.getAttribute('data-section-type');
    const isMobileDrawerSection =
      sectionType === 'mobile-drawer' ||
      selectedSection.contains(drawer) ||
      !!selectedSection.querySelector('#MobileDrawer');

    if (isMobileDrawerSection) {
      if (!drawer.classList.contains('is-open')) {
        openDrawer();
      }
    } else {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    }
  });

  document.addEventListener('shopify:section:deselect', () => {
    if (!(window.Shopify && Shopify.designMode)) return;
    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
})();

(() => {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const root = document.documentElement;
  let lastHeaderHeight = -1;

  const setBodyOffset = () => {
    if (!document.body) return;

    const headerHeight = Math.max(0, Math.round(header.offsetHeight));

    if (headerHeight === lastHeaderHeight) return;
    lastHeaderHeight = headerHeight;

    root.style.setProperty('--header-height', `${headerHeight}px`);
    document.body.style.paddingTop = `${headerHeight}px`;
  };

  setBodyOffset();
  window.addEventListener('load', setBodyOffset);
  window.addEventListener('resize', setBodyOffset);

  let resizeObserver = null;
  if ('ResizeObserver' in window) {
    resizeObserver = new ResizeObserver(() => setBodyOffset());
    resizeObserver.observe(header);
  }
})();

document
  .querySelectorAll('.site-header__bottom .sub-nav')
  .forEach(function (subNav) {
    const list = subNav.querySelector('.sub-nav__list');
    const bar = subNav.querySelector('.sub-nav__scrollbar');
    const thumb = subNav.querySelector('.sub-nav__thumb');
    if (!list || !bar || !thumb) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let draggingThumb = false;

    const updateCanScroll = () => {
      const canScrollLeft = list.scrollLeft > 0;
      const canScrollRight =
        list.scrollLeft + list.clientWidth < list.scrollWidth - 1;
      subNav.classList.toggle('can-left', canScrollLeft);
      subNav.classList.toggle('can-right', canScrollRight);
      const barWidth = bar.clientWidth;
      const contentWidth = Math.max(1, list.scrollWidth);
      const viewportWidth = Math.max(1, list.clientWidth);
      const ratio = Math.min(1, viewportWidth / contentWidth);
      const thumbWidth = Math.max(24, Math.round(barWidth * ratio));
      const maxScroll = Math.max(1, contentWidth - viewportWidth);
      const progress = maxScroll ? list.scrollLeft / maxScroll : 0;
      const maxThumbX = Math.max(0, barWidth - thumbWidth);
      const thumbX = Math.round(maxThumbX * progress);
      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translateX(${thumbX}px)`;
      const hasOverflow = contentWidth > viewportWidth + 1;
      subNav.classList.toggle('has-overflow', hasOverflow);
    };
    updateCanScroll();
    window.addEventListener('resize', updateCanScroll);

    let scrollTimeout = null;
    const handleScroll = () => {
      updateCanScroll();
      subNav.classList.add('is-scrolling');
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(() => {
        subNav.classList.remove('is-scrolling');
        scrollTimeout = null;
      }, 1000);
    };
    list.addEventListener('scroll', handleScroll, { passive: true });
    list.addEventListener('mousedown', (e) => {
      isDown = true;
      subNav.classList.add('is-dragging');
      startX = e.pageX - list.offsetLeft;
      scrollLeft = list.scrollLeft;
    });
    const handleMouseUp = () => {
      isDown = false;
      draggingThumb = false;
      subNav.classList.remove('is-dragging');
    };
    window.addEventListener('mouseup', handleMouseUp);
    list.addEventListener('mouseleave', () => {
      isDown = false;
      subNav.classList.remove('is-dragging');
    });
    list.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - list.offsetLeft;
      const walk = (x - startX) * 1;
      list.scrollLeft = scrollLeft - walk;
    });
    let touchMoved = false;
    let touchTargetLink = null;
    let startClientX = 0;
    let startClientY = 0;
    list.addEventListener(
      'touchstart',
      (e) => {
        subNav.classList.add('is-dragging');
        touchMoved = false;
        const t = e.touches && e.touches[0];
        if (t) {
          startClientX = t.clientX;
          startClientY = t.clientY;
        }
        touchTargetLink =
          e.target && e.target.closest && e.target.closest('a.sub-nav__link');
      },
      { passive: true }
    );
    list.addEventListener(
      'touchmove',
      (e) => {
        const t = e.touches && e.touches[0];
        if (!t) return;
        const dx = Math.abs(t.clientX - startClientX);
        const dy = Math.abs(t.clientY - startClientY);
        if (dx > 6 || dy > 6) touchMoved = true;
      },
      { passive: true }
    );
    list.addEventListener(
      'touchend',
      () => {
        subNav.classList.remove('is-dragging');
        if (!touchMoved && touchTargetLink) {
          touchTargetLink.click();
        }
        touchTargetLink = null;
      },
      { passive: true }
    );
    const positionToScrollLeft = (clientX) => {
      const barRect = bar.getBoundingClientRect();
      const barWidth = barRect.width;
      const currentThumbWidth = thumb.offsetWidth;
      const maxThumbX = Math.max(0, barWidth - currentThumbWidth);
      const x = Math.min(
        Math.max(0, clientX - barRect.left - currentThumbWidth / 2),
        maxThumbX
      );
      const progress = maxThumbX ? x / maxThumbX : 0;
      const maxScroll = Math.max(1, list.scrollWidth - list.clientWidth);
      return Math.round(maxScroll * progress);
    };
    thumb.addEventListener('mousedown', (e) => {
      draggingThumb = true;
      subNav.classList.add('is-dragging');
      e.preventDefault();
    });
    window.addEventListener('mousemove', (e) => {
      if (!draggingThumb) return;
      e.preventDefault();
      list.scrollLeft = positionToScrollLeft(e.clientX);
    });
    bar.addEventListener('mousedown', (e) => {
      if (e.target === thumb) return;
      subNav.classList.add('is-dragging');
      list.scrollLeft = positionToScrollLeft(e.clientX);
      setTimeout(() => {
        subNav.classList.remove('is-dragging');
      }, 100);
    });
  });

(() => {
  function getLocalePrefix() {
    try {
      const pathname = window.location.pathname;
      const match = pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/);
      return match ? '/' + match[1] : '';
    } catch (e) {
      return '';
    }
  }

  function getLocalePrefixFromUrl(pathname) {
    if (!pathname || !pathname.startsWith('/')) return null;
    const match = pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/);
    return match ? '/' + match[1] : null;
  }

  function isShortLocaleCode(prefix) {
    if (!prefix) return false;
    return /^\/[a-z]{2}$/.test(prefix);
  }

  function addLocalePrefixToUrl(url) {
    const currentPrefix = getLocalePrefix();
    if (!currentPrefix) return url;

    try {
      if (url.startsWith('http://') || url.startsWith('https://')) {
        try {
          const urlObj = new URL(url);
          if (urlObj.origin !== window.location.origin) {
            return url;
          }
          const pathname = urlObj.pathname;
          const urlPrefix = getLocalePrefixFromUrl(pathname);

          if (urlPrefix) {
            if (urlPrefix === currentPrefix) {
              return url;
            } else if (
              isShortLocaleCode(urlPrefix) &&
              !isShortLocaleCode(currentPrefix)
            ) {
              const rest = pathname.substring(urlPrefix.length);
              urlObj.pathname = currentPrefix + rest;
              return urlObj.toString();
            } else {
              return url;
            }
          } else {
            urlObj.pathname = currentPrefix + pathname;
            return urlObj.toString();
          }
        } catch (e) {
          return url;
        }
      }

      if (url.startsWith('/')) {
        const urlPrefix = getLocalePrefixFromUrl(url);

        if (urlPrefix) {
          if (urlPrefix === currentPrefix) {
            return url;
          } else if (
            isShortLocaleCode(urlPrefix) &&
            !isShortLocaleCode(currentPrefix)
          ) {
            const rest = url.substring(urlPrefix.length);
            return currentPrefix + rest;
          } else {
            return url;
          }
        } else {
          return currentPrefix + url;
        }
      }

      return url;
    } catch (e) {
      return url;
    }
  }

  function processLink(link) {
    if (!link || !link.href) return;

    if (link.dataset.localeProcessed === 'true') return;

    const originalHref = link.getAttribute('href');
    if (!originalHref) return;

    if (
      originalHref.startsWith('javascript:') ||
      originalHref.startsWith('#') ||
      originalHref.startsWith('mailto:') ||
      originalHref.startsWith('tel:') ||
      originalHref === '' ||
      originalHref.trim() === ''
    ) {
      return;
    }

    if (
      originalHref.startsWith('http://') ||
      originalHref.startsWith('https://')
    ) {
      try {
        const urlObj = new URL(originalHref);
        if (urlObj.origin !== window.location.origin) {
          return;
        }
      } catch (e) {
        return;
      }
    }

    const newHref = addLocalePrefixToUrl(originalHref);
    if (newHref !== originalHref) {
      link.setAttribute('href', newHref);
    }

    link.dataset.localeProcessed = 'true';
  }

  function processAllLinks() {
    const links = document.querySelectorAll('a[href]');
    links.forEach(processLink);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAllLinks);
  } else {
    processAllLinks();
  }

  window.addEventListener('load', () => {
    setTimeout(processAllLinks, 100);
  });

  document.addEventListener(
    'click',
    function (e) {
      const link = e.target.closest('a[href]');
      if (!link) return;

      processLink(link);

      const href = link.getAttribute('href');
      if (
        !href ||
        href.startsWith('javascript:') ||
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:')
      ) {
        return;
      }

      if (href.startsWith('http://') || href.startsWith('https://')) {
        try {
          const urlObj = new URL(href);
          if (urlObj.origin !== window.location.origin) {
            return;
          }
        } catch (e) {
          return;
        }
      }

      const newHref = addLocalePrefixToUrl(href);

      if (newHref !== href) {
        e.preventDefault();
        e.stopPropagation();

        window.location.href = newHref;
        return false;
      }
    },
    true
  );

  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.tagName === 'A' && node.href) {
              processLink(node);
            }
            const links =
              node.querySelectorAll && node.querySelectorAll('a[href]');
            if (links) {
              links.forEach(processLink);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
